import { FORTA_BLUE } from '../../utils/colors';

import type { IconProps } from './types';

const ExclamationIcon = (props: IconProps) => {
  const { color = FORTA_BLUE.light1, width = 24, height = 25, viewBox = '0 0 24 25' } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={`${width}`}
      height={`${height}`}
      viewBox={`${viewBox}`}
      fill="none"
    >
      <path
        d="M12 22.2739C6.47715 22.2739 2 17.7967 2 12.2739C2 6.75108 6.47715 2.27393 12 2.27393C17.5228 2.27393 22 6.75108 22 12.2739C22 17.7967 17.5228 22.2739 12 22.2739ZM12 20.2739C16.4183 20.2739 20 16.6922 20 12.2739C20 7.85565 16.4183 4.27393 12 4.27393C7.58172 4.27393 4 7.85565 4 12.2739C4 16.6922 7.58172 20.2739 12 20.2739ZM11 15.2739H13V17.2739H11V15.2739ZM11 7.27393H13V13.2739H11V7.27393Z"
        fill={color}
      />
    </svg>
  );
};

export default ExclamationIcon;
